/*
import external dependencies
import 'jquery';

import local dependencies

import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
*/


/** Populate Router instance with DOM routes */

/*
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
*/

/*
document.addEventListener("DOMContentLoaded", (event) => {
    console.log('DOM is ready.')
});

window.onload=function() {
	alert("works");
}


function ready(callbackFunction){
  if(document.readyState != 'loading')
    callbackFunction(event)
  else
    document.addEventListener("DOMContentLoaded", callbackFunction)
}

ready(event => {

};

  console.log('DOM is ready.')
})
*/
var globals={
	slideIndex: -1,
}

document.onreadystatechange = () => {
	if (document.readyState === 'complete') {
		prepareDocument()	

	}


}

function prepareDocument() {
	document.getElementsByTagName('body')[0].classList.add('loaded');
	setTimeout(function() {
		document.getElementById('loader-wrapper').style.display='none';
	}, 2000);

	document.addEventListener("scroll", navScroll);
	document.addEventListener("scroll", contentScroll);
	document.getElementById("nav-button").addEventListener("click", toggleNav);
	window.addEventListener("resize", resizeNav);

	if(document.getElementById("slider")) {

		document.getElementById("slider-button").addEventListener("click", slideScroll);
		globals.slideIndex = 0;
		slideShow();	
	}

	var navLinks=document.getElementsByClassName('vc-abstract-link-container');
	for(var i=0; i<navLinks.length; i++) {
		navLinks[i].addEventListener("click", toggleSublinks);
		var sublinks=navLinks[i].getElementsByTagName('ul');
		sublinks[0].addEventListener("mouseleave", closeSublinks);
	}

	window.scrollBy(0,1);
}


function closeSublinks() {

	var navLinks=document.getElementsByClassName('vc-abstract-link-container');
	for(var i=0; i<navLinks.length; i++) {
		if(navLinks[i].classList.contains("opened-sublinks")) {
			navLinks[i].classList.remove("opened-sublinks");
			navLinks[i].classList.add("closed-sublinks");
		}
	}

	var wrap=document.getElementById("wrap");
	if(wrap.classList.contains("active-sublinks")) {
		wrap.classList.remove("active-sublinks")
	}

}


function toggleSublinks() {

	
	if(this.classList.contains("opened-sublinks")) {
		closeSublinks();		
	} else {
		closeSublinks();	
		this.classList.remove("closed-sublinks");
		this.classList.add("opened-sublinks");
		var wrap=document.getElementById("wrap");
		wrap.classList.add("active-sublinks")
	}

}

function navScroll() {
	
	var header=document.getElementById('wrap')
	if(document.documentElement.scrollTop>50 || document.body.scrollTop>50) {
		if(!header.classList.contains("scrolled")) {
			header.classList.add("scrolled");
		}
	} else {
		if(header.classList.contains("scrolled")) {
			header.classList.remove("scrolled");
		}

	}
}


function contentScroll () {

	var sections=document.getElementsByClassName('home-section');
	
	for(var i=0; i<sections.length; i++) {
		if(elementComesInScroll(sections[i])) {
			sections[i].classList.add("passed");
		}
	}
}

function slideScroll() {
	var pc=document.getElementsByClassName('page-content')[0];
	var offset=pc.offsetTop;
	var f=document.getElementsByTagName('html')[0];
	var g=window.getComputedStyle(f, null).getPropertyValue('font-size');
	var heightDiff=g.substring(0,(g.length-2));
	var wheight=offset-heightDiff-64-26; //window.screen.availHeight-7*heightDiff+5;
	scrollIt(wheight, 700, 'easeOutQuad', ()=>{});
	
}


function toggleNav() {
	closeSublinks();
	var nav=document.getElementById('wrap');
	if(nav.classList.contains("opened")) {
		nav.classList.remove("opened");
		nav.classList.add("closed");
	} else {
		nav.classList.add("opened");
		nav.classList.remove("closed");
	}

	var butt=document.getElementById('nav-button').children[0];
	if(butt.classList.contains("mdi-menu")) {
		butt.classList.remove("mdi-menu");
		butt.classList.add("mdi-close");
	} else {
		butt.classList.add("mdi-menu");
		butt.classList.remove("mdi-close");
	}



}

function resizeNav() {

	closeSublinks();
	var nav=document.getElementById('wrap');
	if(nav.classList.contains("opened")) {
		nav.classList.remove("opened");
		nav.classList.add("closed");
	}
	
	var butt=document.getElementById('nav-button').children[0];
	if(butt.classList.contains("mdi-close")) {
		butt.classList.remove("mdi-close");
		butt.classList.add("mdi-menu");
	} 


}

function slideShow() {
	var i;
	var slides = document.getElementsByClassName("slide-item");
	for (i = 0; i < slides.length; i++) {
		slides[i].classList.remove('active'); 
	}
	globals.slideIndex++;
	if (globals.slideIndex > slides.length) {globals.slideIndex = 1} 
	slides[globals.slideIndex-1].classList.add('active');
	setTimeout(slideShow, 5000); 

}




function scrollIt(destination, duration = 200, easing = 'linear', callback) {

  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return (--t) * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - (--t) * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + (--t) * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
    },
  };

  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);


  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  function scroll() {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - startTime) / duration));
    const timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));
    if (window.pageYOffset >= destinationOffsetToScroll-2) {

      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  }

  scroll();
}


function elementComesInScroll(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
	//var elemHeight=rect.height;

    // Only completely visible elements return true:
    //var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // Partially visible elements return true:
    var isVisible = elemTop+250 < window.innerHeight && elemBottom >= 0;
	return isVisible;
}



// WEBPACK FOOTER //
// ./scripts/main.js